import Vue from 'vue';
import HeroImage from '@app/components/HeroElements/Image.vue';
import HeroContent from '@app/components/HeroElements/Content.vue';
import HeroMoodVideo from '@app/components/HeroElements/MoodVideo.vue';
import HeroFullVideo from '@app/components/HeroElements/FullVideo.vue';
export default Vue.extend({
    components: {
        HeroImage: HeroImage,
        HeroContent: HeroContent,
        HeroMoodVideo: HeroMoodVideo,
        HeroFullVideo: HeroFullVideo,
    },
    props: {
        block: Object
    },
    data: function () { return ({
        fullVideoReady: false
    }); },
    computed: {
        logo: function () {
            return this.$helpers.taggedFirst(this.block.images, 'logo');
        }
    },
});
